/**
 * 图文页面
 * Create by liaokai on 2020-03-20 17:17:20
 */
import * as React from 'react';
import {Component} from "react";
import {api} from '../../../../common/app'
import wx from 'weixin-jsapi'

export class Article extends Component{
    constructor(props){
        super(props);
        this.state = {
            content : ""
        }
        let {id} = this.props.match.params;
        api.getModelInfo(id).then(res => {
            document.title = res.result.title+"-"+res.result.meetTitle
        })
    }

    componentDidMount() {
        let {id} = this.props.match.params;
        api.getModelDetail(id).then(res => {
            this.setState({content : res.result[0].content})
        })

    }

    /**
     * 富文本点击查看大图
     * @param {*} event 
     */
    onClick = (event) => {
        if (event.target.tagName === 'IMG') {
            console.log('event', event.target.tagName);
            wx.previewImage({
                current: event.target.src,
                urls: [event.target.src]
            });
        }
    }

    render() {
        let {} = this.props;
        let {content} = this.state;
        return (
            <div style={{padding : 20}}>
                <div 
                    dangerouslySetInnerHTML={{
                        __html: `<html style="background: red">
                            <header>
                                <style>
                                    body img{
                                        max-width: 100%;
                                    }
                                    body * {
                                        line-height: 1.3rem;
                                    }
                                </style>
                            </header>
                            <body>
                                ${content}
                            </body>
                        </html>`
                    }}
                    onClick={this.onClick.bind(this)}
                />
            </div>
        );
    }
}
